import "@rails/ujs";

import "@hotwired/turbo-rails";
import Rails from "@rails/ujs";
import "@/controllers/index.js";

import "core-js";
import "bootstrap/dist/js/bootstrap.min.js";

import "@/common/jquery.js";
import "@/application/common.js";

Rails.start();

// カスタムTurbo Stream アクション: リダイレクト
import { StreamActions } from "@hotwired/turbo";
StreamActions.redirect = function () {
  Turbo.visit(this.target);
};

// Turbo Streamによる描画をすべて捕捉
document.addEventListener('turbo:before-stream-render', (event) => {
  const eventData = {
    page_location: window.location.href,
    navigation_type: 'turbo_stream',
    stream_action: event.detail.newStream.action,
    stream_target: event.detail.newStream.target
  };

  window.dataLayer = window.dataLayer || [];
  dataLayer.push({
    event: 'page_view',
    ...eventData
  });

  if (typeof gtag !== 'undefined') {
    gtag('event', 'page_view', eventData);
  }
});

// Turbo Frameイベント
document.addEventListener('turbo:frame-render', (event) => {
  const fetchResponse = event.detail.fetchResponse;
  const location = fetchResponse?.location?.href || window.location.href;
  const httpMethod = fetchResponse?.response?.headers?.get('X-Http-Method-Override') || 'GET';

  const eventData = {
    page_location: location,
    page_path: new URL(location).pathname,
    navigation_type: 'turbo_frame',
    frame_id: event.target.id,
    http_method: httpMethod
  };

  window.dataLayer = window.dataLayer || [];
  dataLayer.push({
    event: 'page_view',
    ...eventData
  });

  if (typeof gtag !== 'undefined') {
    gtag('event', 'page_view', eventData);
  }
});

// 前回のclassをsessionStorageから取得
const previousClass = sessionStorage.getItem('bodyClass') || '';
const currentClass = document.body.className;

// classが変わっていたらトラッキング
if (previousClass && previousClass !== currentClass) {
  const eventData = {
    controller: document.body.classList[0],
    action: document.body.classList[1],
    path: window.location.pathname
  };

  window.dataLayer = window.dataLayer || [];
  dataLayer.push({
    event: 'rails_render',
    ...eventData
  });

  if (typeof gtag !== 'undefined') {
    gtag('event', 'rails_render', eventData);
  }
}

// 現在のclassを保存
sessionStorage.setItem('bodyClass', currentClass);
